import React from 'react';
import { useCursorSupport } from '../hooks/useCursorSupport';
import { useCursorTracking, TRAIL_LIFE_MS, SPARKLE_LIFE_MS } from '../hooks/useCursorTracking';

const CursorEffect = () => {
  const enabled = useCursorSupport();
  const { position, isPointer, isClicking, trails, sparkles } = useCursorTracking();

  if (!enabled) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[9999]">
      {/* Trail particles */}
      {trails.map((trail) => {
        const age = Date.now() - trail.born;
        const opacity = Math.max(0, 1 - age / TRAIL_LIFE_MS) * 0.5;
        const scale = Math.max(0, 1 - age / TRAIL_LIFE_MS) * 0.6;
        return (
          <div
            key={trail.id}
            className="absolute rounded-full"
            style={{
              left: trail.x,
              top: trail.y,
              width: 8,
              height: 8,
              background: '#00BCE4',
              opacity,
              transform: `translate(-50%, -50%) scale(${scale})`,
              boxShadow: `0 0 8px rgba(0,188,228,${opacity}), 0 0 3px rgba(0,0,0,0.2)`,
              transition: 'opacity 0.15s ease-out',
            }}
          />
        );
      })}

      {/* Click sparkle bursts */}
      {sparkles.map((s) => {
        const age = Date.now() - s.born;
        const progress = age / SPARKLE_LIFE_MS;
        const dist = progress * 50;
        const opacity = Math.max(0, 1 - progress);
        const sx = s.x + Math.cos(s.angle) * dist;
        const sy = s.y + Math.sin(s.angle) * dist;
        return (
          <div
            key={s.id}
            className="absolute rounded-full"
            style={{
              left: sx,
              top: sy,
              width: 4,
              height: 4,
              background: '#00BCE4',
              opacity,
              transform: 'translate(-50%, -50%)',
              boxShadow: '0 0 6px #00BCE4, 0 0 2px rgba(0,0,0,0.3)',
            }}
          />
        );
      })}

      {/* Main cursor ring */}
      <div
        className="absolute rounded-full transition-all duration-150 ease-out"
        style={{
          left: position.x,
          top: position.y,
          width: isPointer ? 48 : 32,
          height: isPointer ? 48 : 32,
          border: `2px solid ${isClicking ? '#FFD700' : '#00BCE4'}`,
          transform: `translate(-50%, -50%) scale(${isClicking ? 0.7 : 1})`,
          opacity: 0.85,
          boxShadow: isClicking
            ? '0 0 20px rgba(255,215,0,0.4), inset 0 0 8px rgba(255,215,0,0.15), 0 0 4px rgba(0,0,0,0.15)'
            : '0 0 12px rgba(0,188,228,0.4), inset 0 0 8px rgba(0,188,228,0.1), 0 0 4px rgba(0,0,0,0.15)',
          transition: 'width 0.2s ease, height 0.2s ease, border-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease',
        }}
      />

      {/* Inner dot */}
      <div
        className="absolute rounded-full"
        style={{
          left: position.x,
          top: position.y,
          width: isClicking ? 8 : 5,
          height: isClicking ? 8 : 5,
          background: isClicking ? '#FFD700' : '#00BCE4',
          transform: 'translate(-50%, -50%)',
          boxShadow: isClicking
            ? '0 0 10px #FFD700, 0 0 3px rgba(0,0,0,0.25)'
            : '0 0 8px #00BCE4, 0 0 3px rgba(0,0,0,0.25)',
          transition: 'width 0.15s ease, height 0.15s ease, background 0.15s ease',
        }}
      />
    </div>
  );
};

export default CursorEffect;
